export default "__VITE_ASSET__BNImyDO8__"